// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

export default class UnpolyLinkHelper {
  static isCachable(link) {
    const cacheAllowed = link.getAttribute('up-cache') !== 'false'
    const cachableUrl = !String(link.getAttribute('href')).match(/\/edit(\?|#|$)/)
    return cacheAllowed && cachableUrl
  };

  static setAttributes(link, attributes) {
    const attrs = Object.assign({ 'up-instant': '' }, attributes)
    if (this.isCachable(link)) {
      attrs['up-preload'] = ''
    } else {
      attrs['up-cache'] = 'false'
    }

    if (link.matches('.btn:not(.btn-link)')) {
      // Buttons should not navigate on mousedown
      delete attrs['up-instant']
    }

    up.element.setAttrs(link, attrs)
  }
}
